import StickyPageHeader from '../components/common/StickyPageHeader';
import DefaultVehicleList from '../components/lists/DefaultVehicleList';
import { useDefaultVehicles } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminVehicleTypesPage = ({ disableLayout, routes }) => {
  const { defaultVehicles } = useDefaultVehicles();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Vehicle Types" />
      <DefaultVehicleList id="vehicles" vehicles={defaultVehicles} />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminVehicleTypesPage;
